import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import moment from 'moment';
import { PromoStackPurchaseService } from '../../core/services/data/promo-stack-purchase.service';
import { UserService } from '../../core/services/data/user.service';

@Component({
	selector: 'app-promo-stack-date-picker',
	templateUrl: './promo-stack-date-picker.component.html',
	styleUrls: ['./promo-stack-date-picker.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class PromoStackDatePickerComponent implements OnInit, OnDestroy {
	@Input() context: 'SOLDOUT' = 'SOLDOUT';

	public promoStackAvailability;

	public loading = true;

	public selectedDate: Date;

	public selectedDateSet;

	public releaseSchedule = [];

	private _availabilitySet;

	private _loading$;

	constructor(
		private promoStackPurchaseService: PromoStackPurchaseService,
		private userService: UserService,
	) { }

	ngOnInit() {
		this._loading$ = this.promoStackPurchaseService.loading$.subscribe((loading) => {
			this._getAvailability();
			this.loading = loading;
		});
	}

	ngOnDestroy(): void {
		if (this._loading$) {
			this._loading$.unsubscribe();
		}
	}

	public selectDate(date: Date, soldout: boolean, memberExclusive: boolean) {
		if (soldout) return;
		// Check Member Exclusivity
		this.selectedDate = date;
		this.selectedDateSet = this._availabilitySet.find(([start]) => start.pubDate.toString() === moment(date).format('YYYYMMDD'));
		this.promoStackPurchaseService.selectDate(this.selectedDate, this.selectedDateSet);
		this.releaseSchedule = this.promoStackPurchaseService.releaseSchedule;
	}

	private _getAvailability() {
		const { availability } = this.promoStackPurchaseService;
		if (!availability) return;
		const _promoStackAvailability = availability.map((item) => item.sort((a, b) => a.pubDate - b.pubDate));

		this._availabilitySet = _promoStackAvailability;

		const dates = _promoStackAvailability.map(([item]) => item.pubDate).sort();
		const endDate = dates[dates.length - 1];
		const startDate = dates[0];
		this.promoStackAvailability = [];
		let currentDate = startDate;
		const allDates = [];

		while (currentDate <= endDate) {
			allDates.push(currentDate);
			currentDate = +moment(currentDate, 'YYYYMMDD').add(1, 'days').format('YYYYMMDD');
		}

		const memberExclusiveCutoff = moment(endDate, 'YYYYMMDD').subtract(14, 'days');
		const paidMember = ['Gold', 'Platinum'].includes(this.userService.me?.memberRole?.roleName);

		this.promoStackAvailability = allDates.map((date) => {
			const item = availability.find(([a]) => a.pubDate === +date);
			return {
				soldout: !item,
				...item,
				day: moment(date, 'YYYYMMDD').format('dddd'),
				date: moment(date, 'YYYYMMDD').format('MMM D, YYYY'),
				pubDate: moment(date, 'YYYYMMDD').format('ddd, MMM D, YYYY'),
				memberExclusive: !paidMember && moment(date, 'YYYYMMDD').isAfter(memberExclusiveCutoff),
			};
		});
	}
}
